export enum StorageKey {
  USER_INFO = "USER_INFO",
  DEVICE_INFO = "DEVICE_INFO",
  DOMAIN_COMPANY = "DOMAIN_COMPANY",
  IS_CLEAR_FCM_TOKEN = "IS_CLEAR_FCM_TOKEN",
  //
  VIDEO_CALL_INFO = "VIDEO_CALL_INFO",
  ACCESS_TOKEN = "ACCESS_TOKEN",
  REFRESH_TOKEN = "REFRESH_TOKEN",
  USER_IMAGE = "USER_IMAGE",
  LANGUAGE = "i18nextLng",
  NEED_APPLY_ADS = "NEED_APPLY_ADS",
}

function save(key: StorageKey, value: any) {
  return localStorage.setItem(key, value);
}

function get(key: StorageKey) {
  const rs = localStorage.getItem(key) || "";
  return rs;
}

function remove(key: StorageKey) {
  return localStorage.removeItem(key);
}

// Sử dụng nếu AsyncStorage dữ liệu dạng Json object
function saveObject(key: string, value: any) {
  localStorage.setItem(key, JSON.stringify(value));
}

// sử dụng nếu AsyncStorage dữ liệu dạng Json object
function getObject(key: string) {
  let value: any = localStorage.getItem(key);
  return JSON.parse(value);
}

export default {
  save,
  get,
  remove,
  saveObject,
  getObject,
};
